import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import HeaderButton from '../../../../components/MenuManager/Header/HeaderButton';
import { MenuItemType } from '../../../../typings/menu';
import DriveItemUtils from '../../../../utils/driveItem';
import { getMenuButtonIconSrc } from '../../../../utils/menuManager';

interface HeaderButtonOwnProps {
	icon?: string;
	label?: string;
	type?: MenuItemType;
	target?: string;
}

enum LocationPathName {
	Folder = '/list/folder',
	Selection = '/list/selection',
}

const mapStateToProps = (state: StoreState, ownProps: HeaderButtonOwnProps) => {
	const {
		appInfos,
		galleryInfos: { config },
		driveList,
		routing: { locationBeforeTransitions: { pathname } },
		routerParamsHistory,
		offlineManager: { thumbMap },
	} = state;
	const { driveItems, resolutions } = driveList;
	const isMultiApp = Utils.isMultiApp(appInfos);

	const { icon, type } = ownProps;
	const iconSrc = getMenuButtonIconSrc(icon, driveItems, config, thumbMap, resolutions);

	const isItemActive = () => {
		if (type === MenuItemType.Selection) {
			return pathname === LocationPathName.Selection;
		} else if (type === MenuItemType.Documents) {
			const currentFolderId = Utils.getCurrentFolderId(config.applicationGallery, routerParamsHistory);
			const privateDirId = Utils.getPrivateDirId(driveList, config);
			const sharedDirId = Utils.getSharedDirId(driveList, config);
			return pathname.includes(LocationPathName.Folder) &&
				DriveItemUtils.isDirDescendantOf(currentFolderId, privateDirId, driveItems) &&
				!DriveItemUtils.isDirDescendantOf(currentFolderId, sharedDirId, driveItems);
		}

		return false;
	};

	return {
		isMultiApp,
		iconSrc,
		isActive: isItemActive(),
	};
};

export default connect(mapStateToProps)(HeaderButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Header/HeaderButton/index.tsx